import { DisconnectOutlined } from '@ant-design/icons';
import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';

interface OfflineIndicatorProps {
  isOnline: boolean;
}

const OfflineIndicator = ({ isOnline }: OfflineIndicatorProps) => {
  const { t } = useTranslation(['common']);

  if (isOnline) {
    return null;
  }

  return (
    <Alert
      type="warning"
      banner
      message={
        <div className="flex items-center">
          <DisconnectOutlined className="mr-2" />
          <span>{t('common:offline_mode')}</span>
        </div>
      }
      className="sticky top-0 z-50"
    />
  );
};

export default OfflineIndicator;
